/**
 * 支持以下事件：
 * * after-login  用户登录
 * * after-logout  用户登出
 * * webview-show  显示webview
 * * webview-hide  隐藏webview
 * * tabbar-click  tabbar被点击
 * * title-click  title被点击（只有setTitle()设置了可点击的才行）
 * * navbar-right-buttons-click  “navbar”右侧按钮组被点击
 * * navbar-left-button-click  “navbar”左侧按钮被点击
 * * navbar-right-popover-click  右上角浮层按钮组
 */
import {supportNative} from './util';
import EventEmitter from 'events';

const event = new EventEmitter();
let zzc = window.zzc;

export default event;

// for test
window.nativeEvent = event;


if (!supportNative()) {
  zzc = event;
}

// after-login 用户登录
// doc: https://doc.oschina.net/tantucom?t=237432
zzc.on('after-login', function () {
  event.emit('after-login');
});

// after-logout 用户登出
// doc: https://doc.oschina.net/tantucom?t=237432
zzc.on('after-logout', function () {
  event.emit('after-logout');
});

// webview-show webview-hide
// doc: https://doc.oschina.net/tantucom?t=237432
zzc.on('visibilitychange', function (res) {
  if (typeof res === 'string') {
    try {
      res = JSON.parse(res);
    } catch (error) {
      // ignore
    }
  }

  if (res.hidden) {
    event.emit('webview-show');
  } else {
    event.emit('webview-hide');
  }
});

// tabbar-click
// doc: https://doc.oschina.net/tantucom?t=237432
zzc.on('app:tabBarClick', function (res) {
  event.emit('tabbar-click', res.data);
});


// title-click
// doc: https://doc.oschina.net/tantucom?t=216536
zzc.on('app:clickNavbarTitle', function () {
  event.emit('title-click');
});


// navbar-right-buttons-click
// doc: https://doc.oschina.net/tantucom?t=216536
zzc.on('app:navbarRightButtonsClick', function (res) {
  // 这里是兼容租租车，租租车的res是一段字符串
  let formatRes = typeof res === 'string' ? JSON.parse(res) : res;
  // 被点击按钮的索引值，从0开始
  let index = parseInt(formatRes.data, 10);
  event.emit('navbar-right-buttons-click', index);
});


// navbar-left-button-click
// doc: https://doc.oschina.net/tantucom?t=216536
zzc.on('app:navbarLeftButtonClick', function () {
  event.emit('navbar-left-button-click');
});


// navbar-right-popover-click
zzc.on('app:navbarRightPopoverClick', function (res) {
  // 这里是兼容租租车，租租车的res是一段字符串
  let formatRes = typeof res === 'string' ? JSON.parse(res) : res;
  let index = parseInt(formatRes.data, 10);
  event.emit('navbar-right-popover-click', index);
});


//showpicker 选择插件的按钮点击完成
zzc.on('app:pickerDidConfirm', function (res) {
  event.emit('picker-did-confrim-click', res.data);
});




//当前行程tab有小红点显示
zzc.on('app:tabBadgeShow', function (res) {
  if(res && res.data && res.data.tabID === 'trip'){
    event.emit('tabBadgeShow');
  }
});



// WEBPACK FOOTER //
// ./src/native/event.js